import React, { useEffect, useState } from 'react'
// import Page from '../../component/Page'
import './dashboard.scss'

import { getBranchList, getBudgetYearsList, getCatalogsList, getTypesList } from './services/api'
// import { useSelector } from 'react-redux'

import ReadyForSale from './readyForSale'
import ByBranch from './byBranch'
import ByCatalogs from './byCatalogs'
import SalePriceTable from './salePriceTable'
import CustomerTypePercent from './customerTypePercent'
import SaleStatisticByItemCatalog from './saleStatisticByItemCatalog'
import DailySummary from './dailySummary'
import IncomeByDate from './incomeByDate'
import SellingTrendByMonth from './sellingTrendByMonth'
import SellingTrendByCatalog from './sellingTrendByCatalog'
import { Grid } from '@mui/material'
import DashboardSkeleton from '../../component/DashboardSkeleton'

export default function Dashboard() {
  // const { profile, loading } = useSelector(state => state.profile)

  const seasons = [
    {
      value: 'แล้ง'
    },
    {
      value: 'ฝน'
    }
  ]

  const [types, setTypes] = useState([])
  const [catalogs, setCatalogs] = useState([])
  const [branchs, setBranchs] = useState([])
  const [budgetYears, setBudgetYears] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const init = async () => {
      const [catalogsData, typesData, branchData, budgetYearsData] = await Promise.all([
        getCatalogsList(),
        getTypesList(),
        getBranchList(),
        getBudgetYearsList()
      ])
      setCatalogs(catalogsData)
      setTypes(typesData)
      setBranchs(branchData)
      setBudgetYears(budgetYearsData)
      setLoading(false)
    }
    init()
  }, [])

  // แสดง skeleton ตอนโหลดข้อมูลตั้งต้นครั้งแรก
  if (loading) {
    return <DashboardSkeleton />
  }

  return (
    <>
      <div class="container-fluid">
        <Grid container spacing={2}>
          <Grid item md={6} xs={12} >
            <div class="card-content-d">
              <ByBranch types={types} budgetYears={budgetYears} seasons={seasons} />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="card-content-d">
              <ByCatalogs types={types} budgetYears={budgetYears} seasons={seasons} />
            </div>
          </Grid>
          <Grid item xs={12} >
            <div class="card-content-d" >
              <SalePriceTable />
            </div>
          </Grid>
          <Grid item xs={12} >
            <div class="card-content-d" >
              <ReadyForSale branchs={branchs} types={types} catalogs={catalogs} budgetYears={budgetYears} seasons={seasons} />
            </div>
          </Grid>
          <Grid item xs={12} >
            <DailySummary />
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="card-content-d">
              <CustomerTypePercent />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="card-content-d">
              <SaleStatisticByItemCatalog />
            </div>
          </Grid>
          <Grid item xs={12}>
            <div class="card-content-d">
              <IncomeByDate />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="card-content-d">
              <SellingTrendByMonth catalogs={catalogs} types={types} />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="card-content-d">
              <SellingTrendByCatalog budgetYears={budgetYears} types={types} catalogs={catalogs} />
            </div>
          </Grid>
        </Grid>
        {/* <Grid container className="card-das">
          <Grid item xs={12} style={{ flexDirection: "column" }}>
            <div class="card-content-d" >
              <ReadyForSale branchs={branchs} types={types} catalogs={catalogs} budgetYears={budgetYears} seasons={seasons} />
            </div>
            <Grid container spacing={2} >
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <ByBranch types={types} budgetYears={budgetYears} seasons={seasons} />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <ByCatalogs types={types} budgetYears={budgetYears} seasons={seasons} />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <CustomerTypePercent />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <SaleStatisticByItemCatalog />
                </div>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex' }}>
                <div class="card-content-d" style={{ border: "none" }}>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                      <DailySummary />
                    </Grid>
                    <Grid item md={8} xs={12} sx={{ paddingTop: { md: "0px !important", xs: '10px', } }}>
                      <IncomeByDate />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <SellingTrendByMonth catalogs={catalogs} types={types} />
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="card-content-d">
                  <SellingTrendByCatalog budgetYears={budgetYears} types={types} catalogs={catalogs} />
                </div>
              </Grid>

            </Grid>
          </Grid>
        </Grid> */}
      </div >
    </>
  )
}
